import { SelectDesignTokens } from '@primeuix/themes/types/select';

export const selectPreset: SelectDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
  },
  colorScheme: {
    dark: {
      root: {
        borderColor: '{nspSlate.500}',
        background: '{nspSlate.500}',
        color: '{nspSlate.0}',
        placeholderColor: '{nspSlate.0}',
        focusBorderColor: '{nspSky.300}',
        hoverBorderColor: '{nspSlate.500}',
      },
      option: {
        color: '{nspSlate.0}',
        focusBackground: '{nspSky.300}',
        selectedBackground: '{nspSky.300}',
        selectedColor: '{nspSlate.950}',
        selectedFocusColor: '{nspSlate.950}',
        selectedFocusBackground: '{nspSky.300}',
      },
      clearIcon: {
        color: '{nspSlate.50}',
      },
      dropdown: {
        color: '{nspSlate.50}',
      },
      overlay: {
        background: '{nspSlate.500}',
      },
    },
    light: {
      root: {
        borderColor: '{nspSlate.0}',
        background: '{nspSlate.0}',
        color: '{nspMist.900}',
        disabledColor: '{nspMist.400}',
        placeholderColor: '{nspMist.400}',
        focusBorderColor: '{nspSky.300}',
        hoverBorderColor: '{nspSlate.0}',
      },
      option: {
        color: '{nspSlate.950}',
        focusBackground: '{nspSky.300}',
        selectedBackground: '{nspSky.300}',
        selectedColor: '{nspSlate.950}',
        selectedFocusColor: '{nspSlate.950}',
        selectedFocusBackground: '{nspSky.300}',
      },
      clearIcon: {
        color: '{nspSlate.50}',
      },
      dropdown: {
        color: '{nspSlate.50}',
      },
      overlay: {
        background: '{nspSlate.0}',
        color: '{nspSlate.950}',
      },
    },
  },
};
